import React from 'react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { APPLICATION_SORT_OPTIONS } from '../../../../constants/variables';
import { CustomSelect } from '../../../../components/CustomSelect';
import { ReactComponent as AscOrDescIcon } from '../../../../assets/images/ascOrDesc.svg';

const styleSelect = {
  '& > div': {
    backgroundColor: 'transparent !important'
  },
  '& fieldset': {
    border: 'none !important'
  },
  width: '160px'
};

export const SortApplication = ({ filter, setFilter, total, disabled, tooltip = null }) => {
  return (
    <Box display="flex" alignItems="center">
      <Box display="flex" alignItems="center">
        <Box
          onClick={() =>
            setFilter((prev) => ({
              ...filter,
              order_type: prev.order_type === 'asc' ? 'desc' : 'asc',
              page: 1
            }))
          }
          sx={{
            cursor: 'pointer',
            marginRight: '10px',
            transition: '0.5s',
            transform: `rotate(${filter.order_type === 'asc' ? '180deg' : '0deg'})`
          }}
          data-testid="Sort"
        >
          <AscOrDescIcon />
        </Box>
        <Typography>Сортировать по:</Typography>

        <CustomSelect
          name="sort"
          size="small"
          sx={styleSelect}
          value={filter.order_by}
          onChange={(e) => setFilter({ ...filter, order_by: e, page: 1 })}
          variant="outlined"
          options={APPLICATION_SORT_OPTIONS}
          placeholder="Номеру заявки"
          disabled={disabled}
          tooltip={tooltip}
        />
      </Box>
      <Typography color="text.secondary" marginLeft="24px">
        Найдено {total} заявок
      </Typography>
    </Box>
  );
};

SortApplication.propTypes = {
  total: PropTypes.number,
  filter: PropTypes.object,
  setFilter: PropTypes.func,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
};
